module.exports = __webpack_public_path__ + "static/media/1.ec18b14e.png";